


































































import { Vue } from 'vue-property-decorator'
import ScreenTile from '../components/ScreenTile.vue'
import AdminAlertList from '../components/alert/AdminAlertList.vue'
import UserAlertList from '../components/alert/UserAlertList.vue'
import { CIcon } from '@coreui/icons-vue'
import { cilAlarmAdd } from '@coreui/icons-pro'
import AddAlertModal from '@/components/alert/AddAlertModal.vue'
import { Alerts } from '../dataLayer/Alerts'
import IAlertTag from '@/viewModel/IAlertTag'
import { mapState } from 'vuex'
import IAlert from '@/viewModel/IAlert'

export default Vue.extend({
  components: {
    ScreenTile,
    AdminAlertList,
    CIcon,
    AddAlertModal,
    UserAlertList,
  },
  data: function () {
    return {
      alertAddIcon: cilAlarmAdd,
      showCreateModal: false,
      filteredTags: [] as number[],
      updateType: 'add',
      alertTags: [] as IAlertTag[],
      showAdmin: false,
      editAlert: undefined as IAlert | undefined,
      showAllAlerts: false,
    }
  },
  watch: {
    showAllAlerts(value) {
      console.log(`Show All Alerts: ${value}`);
      //this.showAllToggle();
    }
  },
  async mounted() {
    await this.loadAlertTags()
  },
  computed: {
    ...mapState(['user']),
  },
  methods: {
    onCreateModalClosed: async function () {
      this.showCreateModal = false
      this.alertTags = await Alerts.loadAlertTags()
      this.$root.$emit('alerts-modified', null)
    },
    loadAlertTags: async function () {
      this.alertTags = await Alerts.loadAlertTags()
    },
    toggleTag: function (tagValue: number) {
      if (this.filteredTags.includes(tagValue)) {
        this.filteredTags = this.filteredTags.filter((x) => x !== tagValue)
      } else {
        this.filteredTags.push(tagValue)
      }
    },
    toggleTagFlag: function (tagValue: number) {
      if (this.filteredTags.includes(tagValue)) {
        this.filteredTags = this.filteredTags.filter(function (value) {
          return value !== tagValue
        })
      } else {
        this.filteredTags.push(tagValue)
      }
    },
    showAddAlert() {
      this.editAlert = undefined
      this.updateType = 'add'
      this.showCreateModal = true
    },
    showEditModal(evt) {
      this.editAlert = evt
      this.updateType = 'edit'
      this.showCreateModal = true
    },
    showAllToggle: function() {
      this.$root.$emit('alerts-modified', null)
    }
  },
})
